import React, { useEffect, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { gql, useMutation, useQuery } from "@apollo/client";
import { useNavigate } from "react-router-dom";
import { useLocation } from "react-router-dom";
import "./styles/CreateCampaign.scss";
import "./styles/pages.scss";
// import FormHeader from "./Components/StepsAction/";
import Step1 from "./Components/Step1";
import { dot } from "../../Shared/SVGs/Shared";
import StepIndecator from "./Components/StepIndecator";
import StepsButton from "./Components/StepsButton";
import Step2 from "./Components/Step2";
import Step3 from "./Components/Step3";
import Step4 from "./Components/Step4";
import Step5 from "./Components/Step5";
import { getCurrentTimezone, removeQueryParams } from "../../utilities";
import { updateCampaignFields, updateCampaignState } from "./CampaignActions";
import moment from "moment";
import { EditorState, convertToRaw, convertFromRaw } from "draft-js";
import Cookies from "js-cookie";

const GET_PRESIGNED_URL = gql`
  query GetPresignedURL($fileName: String!) {
    getPresignedURL(fileName: $fileName)
  }
`;

const GET_CAMPAIGN = gql`
  mutation MyMutation($campaignId: ID!, $campaign: clipupInput!) {
    updateCampaign(campaignId: $campaignId, campaign: $campaign) {
      _id
      name
      logo_url
      banner_url
      reward_type
      reward
      start_date
      end_date
      start_time
      end_time
      hash_tag
      timezone
      campaign_product
      generate_qr
      campaign_description
      terms_and_conditions
      termAndConditionRenderAs
      descriptionRenderAs
      ongoing
      manufacturer {
        _id
        name
      }
      products {
        _id
        name
      }
      rating_enabled
      video_time_limit
      bannerRenderAs
      clicks
      status
      description_editor_state
      terms_and_conditions_editor_state
      color_change_hashtag
      preview_color_change
      campaign_headline_editor
      brand_instruction
      campaign_hashtag_editor
      campaign_video_length_type
      campaign_button_color
      campaign_button_text_color
      brand_instruction_editor_state
      hashtag_editor_state
      headline_editor_state
      campaign_upload_platform
    }
  }
`;

const CreateCampaign = () => {
  const [qrcode, setQrcode] = useState(false);
  const [editable, setEditable] = useState(false);
  const [isColorPickerOpen, setIsColorPickerOpen] = useState(false);
  const [isColorPickerOpen1, setIsColorPickerOpen1] = useState(false);
  const activeStep = useSelector((state) => state.campaign_states.activeStep);
  const form = useSelector((state) => state.campaign_states.form);
  const campaign_states = useSelector((state) => state.campaign_states);
  const timezones = useSelector((state) => state.campaign_states.timezones);
  const campaign_response = useSelector(
    (state) => state.campaign_states.campaign_response
  );
  const campaign_video_length_type = useSelector(
    (state) => state.campaign_states.form.campaign_video_length_type
  );
  const dispatch = useDispatch();

  const editHandler = () => {
    if (campaign_response?._id) {
      handleSubmit();
    }
    setEditable(!editable);
    setIsColorPickerOpen(false);
    setIsColorPickerOpen1(false);
  };

  const [
    updateCampaign,
    { data: CampaignData, loading: createCampaignLoading, error },
  ] = useMutation(GET_CAMPAIGN, {
    skip: true,
    onError: (error) => {
      console.log(error);
    },
  });

  const { refetch } = useQuery(GET_PRESIGNED_URL, {
    skip: true,
  });

  const handleSubmit = async () => {
    const {
      campaign_headline,
      campaign_hashtag,
      campaign_brand_name,
      campaign_brand_image,
      campaign_reward,
      start_date,
      end_date,
      start_time,
      end_time,
      campaign_timezone,
      products,
      ongoing,
      campaign_video_limit,
      campaign_allow_rating,
      campaign_video_length,
      terms_and_conditions,
      campaign_description,
      campaign_reward_type,
      campaign_banner_image_file,
      campaign_banner_image_preview,
      image_dimensions,
      description_editor_state,
      terms_and_conditions_editor_state,
      brand_instruction,
      brand_instruction_editor_state,
      campaign_video_length_type,
      campaign_headline_editor,
      campaign_hashtag_editor,
      headline_editor_state,
      hashtag_editor_state,
      preview_color_change,
      campaign_button_color,
      campaign_button_text_color,
      campaign_upload_platform,
    } = form;
    try {
      let serializedContentDesc = null;
      let serializedContentBrand = null;
      let serializedContentHashtag = null;
      let serializedContentHeadline = null;
      let serializedContentTerm = null;

      if (description_editor_state) {
        const rawContentStateDesc = convertToRaw(
          description_editor_state.getCurrentContent()
        );
        serializedContentDesc = JSON.stringify(rawContentStateDesc);
      }

      if (headline_editor_state) {
        const rawContentStateHead = convertToRaw(
          headline_editor_state.getCurrentContent()
        );
        serializedContentHeadline = JSON.stringify(rawContentStateHead);
      }

      if (hashtag_editor_state) {
        const rawContentStateHash = convertToRaw(
          hashtag_editor_state.getCurrentContent()
        );
        serializedContentHashtag = JSON.stringify(rawContentStateHash);
      }

      if (brand_instruction_editor_state) {
        const rawContentStateBrand = convertToRaw(
          brand_instruction_editor_state.getCurrentContent()
        );
        serializedContentBrand = JSON.stringify(rawContentStateBrand);
      }

      if (terms_and_conditions_editor_state) {
        const rawContentStateTerm = convertToRaw(
          terms_and_conditions_editor_state.getCurrentContent()
        );
        serializedContentTerm = JSON.stringify(rawContentStateTerm);
      }
      const newProducts = products
        ?.filter((product) => product?.__isNew__)
        .map((product) => product?.label);

      const formattedStartTime = start_time.format("HH:mm");
      const formattedEndTime = end_time && end_time.format("HH:mm");

      const formattedStartDate = moment(start_date).set({
        hour: start_time.hour(),
        minute: start_time.minute(),
      });

      const formattedEndDate = ongoing
        ? false
        : moment(end_date).set({
            hour: end_time.hour(),
            minute: end_time.minute(),
          });

      let campaignBannerImage = campaign_banner_image_preview || "";

      if (campaign_banner_image_file) {
        const { data: urlData } = await refetch({
          fileName: campaign_banner_image_file.name,
        });

        // Upload File to preassigned URL
        const uploadImageResponse = await fetch(urlData.getPresignedURL, {
          method: "PUT",
          headers: {
            "Content-Type": campaign_banner_image_file.type,
          },
          body: campaign_banner_image_file,
        });

        if (!uploadImageResponse.ok) {
          setLoading(false);
          throw new Error("Failed to upload image");
        }

        campaignBannerImage = removeQueryParams(urlData.getPresignedURL);
      }

      const campaignData = {
        description_editor_state: serializedContentDesc,
        brand_instruction_editor_state: serializedContentBrand,
        headline_editor_state: serializedContentHeadline,
        hashtag_editor_state: serializedContentHashtag,
        terms_and_conditions_editor_state: serializedContentTerm,
        status: "",
        campaign_banner_image: campaignBannerImage,
        campaign_hashtag,
        campaign_brand_image,
        campaign_brand_name,
        campaign_description,
        brand_instruction,
        campaign_headline_editor,
        campaign_upload_platform,
        campaign_hashtag_editor,
        campaign_headline,
        preview_color_change,
        campaign_button_color,
        campaign_button_text_color,
        campaign_product: "campaign_product",
        campaign_reward,
        campaign_reward_type,
        campaign_timezone,
        manufacturer: {
          _id: Cookies.get("bId"),
          name: campaign_brand_name,
        },
        products: products
          ?.filter((product) => !product?.__isNew__)
          .map((product) => ({
            _id: product?.value,
            name: product?.label,
          })),
        ...(newProducts?.length > 0 && { newProducts }),
        start_date: formattedStartDate,
        start_time: formattedStartTime,
        ...(ongoing ? {} : { end_date: formattedEndDate }),
        ongoing,
        end_time: formattedEndTime,
        terms_and_conditions,
        ...(campaign_video_limit > 0 && { campaign_video_limit }),
        campaign_allow_rating,
        campaign_video_time_limit: `${campaign_video_length}`,
        campaign_video_length_type,
        descriptionRenderAs: "html",
        termAndConditionRenderAs: "html",
        bannerRenderAs: image_dimensions,
      };

      const { data: response } = await updateCampaign({
        variables: {
          campaign: campaignData,
          campaignId: campaign_response._id,
        },
      });

      if (response) {
        dispatch(
          updateCampaignState({ campaign_response: response.updateCampaign })
        );
      }
    } catch (error) {
      console.error(error);
    }
  };

  useEffect(() => {
    const myTimezone = getCurrentTimezone();
    const timezoneExists = timezones.some((tz) => tz.value === myTimezone);
    if (!timezoneExists) {
      dispatch(
        updateCampaignState({
          timezones: [...timezones, { value: myTimezone, label: myTimezone }],
        })
      );
    }
  }, []);

  const location = useLocation();

  useEffect(() => {
    const params = new URLSearchParams(location.search);
    const id = params.get("id");
    if (id) {
      updateCampaign({
        variables: {
          campaign: {},
          campaignId: id,
        },
      }).then((result) => {
        if (result.data && result.data.updateCampaign) {
          const campaignData = result.data.updateCampaign;
          dispatch(updateCampaignState({ campaign_response: campaignData }));

          let editorStateDesc = EditorState.createEmpty();
          if (campaignData?.description_editor_state) {
            try {
              const rawContentStateDesc = JSON.parse(
                campaignData?.description_editor_state
              );
              rawContentStateDesc.entityMap =
                rawContentStateDesc?.entityMap || {};
              const contentStateDesc = convertFromRaw(rawContentStateDesc);
              editorStateDesc = EditorState.createWithContent(contentStateDesc);
            } catch (error) {
              console.error("Error parsing description_editor_state:", error);
            }
          }

          let editorStateBrand = EditorState.createEmpty();
          if (campaignData?.brand_instruction_editor_state) {
            try {
              const rawContentStateBrand = JSON.parse(
                campaignData?.brand_instruction_editor_state
              );
              rawContentStateBrand.entityMap =
                rawContentStateBrand?.entityMap || {};
              const contentStateBrand = convertFromRaw(rawContentStateBrand);
              editorStateBrand =
                EditorState.createWithContent(contentStateBrand);
            } catch (error) {
              console.error("Error parsing description_editor_state:", error);
            }
          }

          let editorStateHead = EditorState.createEmpty();
          if (campaignData?.headline_editor_state) {
            try {
              const rawContentStateHead = JSON.parse(
                campaignData?.headline_editor_state
              );
              rawContentStateHead.entityMap =
                rawContentStateHead?.entityMap || {};
              const contentStateHead = convertFromRaw(rawContentStateHead);
              editorStateHead = EditorState.createWithContent(contentStateHead);
            } catch (error) {
              console.error("Error parsing description_editor_state:", error);
            }
          }

          let editorStateHash = EditorState.createEmpty();
          if (campaignData?.hashtag_editor_state) {
            try {
              const rawContentStateHash = JSON.parse(
                campaignData?.hashtag_editor_state
              );
              rawContentStateHash.entityMap =
                rawContentStateHash?.entityMap || {};
              const contentStateHash = convertFromRaw(rawContentStateHash);
              editorStateHash = EditorState.createWithContent(contentStateHash);
            } catch (error) {
              console.error("Error parsing description_editor_state:", error);
            }
          }

          let editorStateTerm = EditorState.createEmpty();
          if (campaignData?.terms_and_conditions_editor_state) {
            try {
              const rawContentStateTerm = JSON.parse(
                campaignData?.terms_and_conditions_editor_state
              );
              rawContentStateTerm.entityMap =
                rawContentStateTerm?.entityMap || {};
              const contentStateTerm = convertFromRaw(rawContentStateTerm);
              editorStateTerm = EditorState.createWithContent(contentStateTerm);
            } catch (error) {
              console.error(
                "Error parsing terms_and_conditions_editor_state:",
                error
              );
            }
          }

          dispatch(
            updateCampaignFields({
              _id: campaignData?._id,
              image_dimensions: campaignData?.bannerRenderAs,
              campaign_banner_image_preview: campaignData?.banner_url,
              descriptionRenderAs: campaignData?.descriptionRenderAs,
              terms_and_conditions: campaignData?.terms_and_conditions,
              campaign_description: campaignData?.campaign_description,
              description_editor_state: editorStateDesc,
              campaign_upload_platform: campaignData?.campaign_upload_platform,
              brand_instruction_editor_state: editorStateBrand,
              hashtag_editor_state: editorStateHash,
              headline_editor_state: editorStateHead,
              terms_and_conditions_editor_state: editorStateTerm,
              ...(campaignData?.end_date && {
                end_date: campaignData?.ongoing
                  ? ""
                  : moment(campaignData?.end_date),
              }),
              ...(campaignData?.end_date && {
                end_time: campaignData?.ongoing
                  ? ""
                  : moment(campaignData?.end_date),
              }),
              ongoing: campaignData?.ongoing,
              campaign_hashtag: campaignData?.hash_tag,
              campaign_brand_image_preview: campaignData?.logo_url,
              campaign_brand_image: campaignData?.logo_url,
              campaign_headline: campaignData?.name,
              campaign_allow_rating: campaignData?.rating_enabled,
              ...(campaignData?.start_date && {
                start_date: moment(campaignData?.start_date),
              }),
              ...(campaignData?.start_date && {
                start_time: moment(campaignData?.start_date),
              }),
              campaign_timezone: campaignData?.timezone,
              campaign_brand_name: campaignData?.manufacturer?.name,
              products: campaignData?.products?.name,
              campaign_video_length: campaignData?.video_time_limit,
              campaign_reward_type: campaignData?.reward_type,
              campaign_reward: campaignData?.reward,
              brand_instruction: campaignData?.brand_instruction,
              campaign_video_length_type:
                campaignData?.campaign_video_length_type,
              campaign_headline_editor: campaignData?.campaign_headline_editor,
              campaign_hashtag_editor: campaignData?.campaign_hashtag_editor,
              preview_color_change: campaignData?.preview_color_change,
              campaign_button_color: campaignData?.campaign_button_color,
              campaign_button_text_color:
                campaignData?.campaign_button_text_color,
            })
          );
        }
      });
    }
  }, []);

  return (
    <div className="CreateCampaign">
      <div className="CreateCampaignContainer">
        <StepsButton qrcode={qrcode} setQrcode={setQrcode} />

        <div className="mt-5 d-flex justify-content-center">
          <div>
            <StepIndecator editHandler={editHandler} editable={editable} />
            {activeStep == 1 && <Step1 />}
            {activeStep == 2 && <Step2 />}
            {activeStep == 3 && <Step3 />}
            {activeStep == 4 && (
              <Step4
                editHandler={editHandler}
                editable={editable}
                isColorPickerOpen={isColorPickerOpen}
                isColorPickerOpen1={isColorPickerOpen1}
                setIsColorPickerOpen={setIsColorPickerOpen}
                setIsColorPickerOpen1={setIsColorPickerOpen1}
              />
            )}
            {activeStep == 5 && <Step5 qrcode={qrcode} setQrcode={setQrcode} />}
          </div>
        </div>
      </div>
    </div>
  );
};
export default CreateCampaign;
